<template>
  <td class="table-date-cell">
    <div class="date-pill" :class="{ overdue: v.overdue }" v-for="v in mapped">
      <span class="off"
        ><ux-icon icon="far fa-clock" left />{{ v.readable }}</span
      >
      <span class="on"
        ><ux-icon icon="far fa-clock" left />{{ v.timeago }}</span
      >
      <span class="spacer"
        ><ux-icon icon="far fa-clock" left />{{ v.readable }}</span
      >
    </div>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";
import { DateTime } from "luxon";

export default {
  mixins: [TableCellMixin],
  methods: {
    timeago(value) {
      return DateTime.fromJSDate(value).toRelative();
    },
    readable(value) {
      value = DateTime.fromJSDate(value);
      let now = DateTime.now();

      //Check against
      let currentYear = now.toFormat("yyyy");
      let currentMonth = now.toFormat("MMM yyyy");

      if (value.toFormat("yyyy") === currentYear) {
        return value.toFormat("h:mm a - dd MMM");
      }

      return value.toFormat("h:mm a - dd MMM yyyy");
    },
  },
  computed: {
    values() {
      if (Array.isArray(this.value)) {
        return this.value;
      } else {
        return [this.value];
      }
    },
    mapped() {
      const self = this;
      return self.values
        .map(function (d) {
          if (!d) {
            return;
          }

          const date = new Date(d);
          const overdue = date < new Date();

          return {
            readable: self.readable(date),
            timeago: self.timeago(date),
            overdue,
          };
        })
        .filter(Boolean);
    },
    // hasValue() {
    //     return this.value !== undefined && this.value !== null;
    // },
  },
};
</script>
<style scoped lang="scss">
td {
  white-space: nowrap;

  div {
    padding: 0.5em 1em;
    margin: 0.1em;
    // background: rgba(#555, 0.1);
    background: color-mix(in lab, currentColor 8%, transparent);

    border-radius: 5em;
    display: block;
    line-height: 1;
    font-size: 0.7em;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    position: relative;
    // min-width: 100px;
    //color: rgba(#666, 0.8);

    &.overdue {
      color: red;
    }

    .spacer {
      visibility: hidden !important;
    }
    .on,
    .off {
      position: absolute;
      left: 0;
      width: 100%;
      transition: opacity 0.1s;
    }

    .on {
      opacity: 0;
    }

    .off {
      opacity: 1;
    }

    &:hover {
      background: color-mix(in lab, currentColor 10%, transparent);

      .off {
        opacity: 0;
      }

      .on {
        opacity: 1;
      }
    }
  }
}
</style>
